export default
{
    "status": 0,
    "data": {
        "posConfig": {
            "supportLanguages": [
                "KO",
                "EN",
                "JP"
            ],
            "defaultLanguage": "KO",
            "useVoiceSupport": true,
            "useAutoOpen": true,
            "useAutoClose": true,
            "autoOpenTime": "0900",
            "autoCloseTime": "2200",
            "currencyUnit": "001",
            "saleUnit": "2",
            "isTaxIncluded": true,
            "amountRoundType": "ROUND",
            "amountUnit": "1",
            "decimalPlace": 0,
            "taxRate": 10,
            "reducedTaxRate": 0,
            "discountRoundType": "ROUND",
            "discountSaleUnit": "1",
            "discountTargetType": "1",
            "useAlarmTalk": false,
            "usePager": false,
            "voucherPrintYN": true,
            "voucherPrintPopupYN": false,
            "receiptPrintYN": true,
            "receiptPrintPopupYN": false,
            "useIdleScreen": true,
            "idleScreenOrderType": 3,
            "idleScreenExtrasType": "0",
            "useIdleScreenAd": "",
            "useIdleScreenText": "",
            "idleScreenButtonHideDelay": 0,
            "returnToIdleDelay": 0,
            "orderScreenNo": "3",
            "templateNo": "C",
            "idleScreenLogo": "",
            "orderScreenLogo": "",
            "mainHighlightColor": "#D81921",
            "subHighlightColor": "#231F20",
            "mainFontColor": "#ffffff",
            "subFontColor": "#7418ee",
            "backgroundColor": "#F5F4F2",
            "deviceInfoList": [
                {
                    "DEVICE_CODE": "DEV01",
                    "CONNECT_TYPE": "02",
                    "PORT": "1",
                    "BAUDRATE": "9600",
                    "IP_ADDRESS": "",
                    "DEVICE_NAME": "영수증프린터"
                }
            ],
            "useKitchenPrinter": true,
            "sideProductExposure": true,
            "recommendProductExposure": false,
            "useAllergyFilter": true,
            "supportPayments": [
                "PAY03",
                "PAY16",
                "PAY17",
                "PAY41",
                "PAY47"
            ],
            "bizTimes": [
                {
                    "DAY": "1",
                    "OPEN_TIME": "0000",
                    "CLOSE_TIME": "2359"
                },
                {
                    "DAY": "2",
                    "OPEN_TIME": "0000",
                    "CLOSE_TIME": "2359"
                },
                {
                    "DAY": "3",
                    "OPEN_TIME": "0000",
                    "CLOSE_TIME": "2359"
                },
                {
                    "DAY": "4",
                    "OPEN_TIME": "0000",
                    "CLOSE_TIME": "2359"
                },
                {
                    "DAY": "5",
                    "OPEN_TIME": "0000",
                    "CLOSE_TIME": "2359"
                },
                {
                    "DAY": "6",
                    "OPEN_TIME": "0000",
                    "CLOSE_TIME": "2359"
                },
                {
                    "DAY": "7",
                    "OPEN_TIME": "0000",
                    "CLOSE_TIME": "2359"
                }
            ]
        },
        "openYn": "N",
        "loginCashierId": "0001"
    },
    "message": ""
}